import { Box, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export function NotificationSearchEmptyState() {
  return (
    <Box
      sx={{
        py: 6,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        bgcolor: 'grey.50',
        borderRadius: 3,
      }}
    >
      <SearchIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
      <Typography variant="body2" color="text.secondary">
        Sök efter innehåll för att skapa djuplänkar eller push-notiser
      </Typography>
    </Box>
  );
}
